import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StateModule } from '@spartacus/core';
import { CART_FEATURE } from './cart-state';
import { effects } from './effects';
import { metaReducers, reducerProvider, reducerToken } from './reducers';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StateModule,
    StoreModule.forFeature(CART_FEATURE, reducerToken, { metaReducers }),
    EffectsModule.forFeature(effects),
  ],
  providers: [reducerProvider],
})
export class CartStoreModule {}
